import { usersReducer } from './usersReducer';
import { usersActions } from './usersActions';
import { usersSagas } from './usersSagas';
export default {
    reducer: usersReducer,
    actions: usersActions,
    sagas: usersSagas,
};
